'use client';

import React, { useEffect, useState } from 'react';

import { Button, Divider, SimpleGrid, VStack, Text } from '@chakra-ui/react';
// import { useRouter } from 'next/navigation';

import { Loader } from '@components/custom-loader';
// import useAuthSelector from '@hooks/useAuthSelector';
import { SlotToBook, SlotWithId } from '@modules/find-mentor/types';
// import { paths } from '@routes/path';
import { convertToUTC } from '@utils/helpers';
// import { PrimaryButton } from '@components/custom-buttons';

import AvailableSlot from './AvailableSlot';

type SessionAvailabilityProps = {
    onNext: () => void;
    slotsForDay: SlotWithId[];
    setSelectedSlot: React.Dispatch<React.SetStateAction<SlotToBook | undefined>>;
    isTodaySelected: boolean;
    isLoading: boolean;
};
const SessionAvailability = ({
    onNext,
    slotsForDay,
    setSelectedSlot,
    isLoading,
    isTodaySelected,
}: SessionAvailabilityProps) => {
    const [availableSlots, setAvailableSlots] = useState<SlotToBook[]>([]);
    // const [meetingDuration] = useState<string>('1:00 hr');
    // const { user, isAuthenticated } = useAuthSelector();
    // const router = useRouter();
    useEffect(() => {
        if (slotsForDay && slotsForDay.length > 0) {
            let slotsArr: SlotToBook[] = slotsForDay.map(slot => ({
                startTime: slot.startTime,
                endEtime: slot.endTime,
                isSelected: false,
            }));
            // filter out hours previous to current hour for today.
            slotsArr = slotsArr.filter(slot => {
                if (!isTodaySelected) {
                    return true;
                }
                return new Date(convertToUTC(slot.startTime)).getHours() >= new Date().getHours();
            });
            setAvailableSlots(slotsArr);
        } else {
            setAvailableSlots([]);
        }
    }, [slotsForDay, isTodaySelected]);
    const onSelect = (index: number) => {
        const localSlots = [...availableSlots];
        localSlots.forEach((item, idx) => {
            if (idx === index) {
                item.isSelected = true;
            } else {
                item.isSelected = false;
            }
        });
        setAvailableSlots(localSlots);
    };

    return (
        <VStack width={{ base: '100%', sm: '100%', md: '100%' }} gap={2} align="center">
            {/* <CustomText color="mainText" size="md" weight={500}>
                Meeting Duration
            </CustomText> */}
            {/* <Box
                width="100%"
                borderRadius={6}
                display="flex"
                alignItems="center"
                justifyContent="center"
                py={2}
                fontWeight={500}
                bgColor="border"
            >
                {meetingDuration}
            </Box> */}
            {/* {isAuthenticated && (
                <VStack align="flex-start" width="100%">
                    <CustomText color="mainText" weight={500}>
                        Time Zone
                    </CustomText>
                    <HStack width="100%" justify="space-between">
                        <CustomText color="mainText">{user?.timezone ?? '-'}</CustomText>
                        <Button
                            type="button"
                            color="blue"
                            variant="link"
                            fontWeight={400}
                            onClick={() => router.replace(paths.mentee.dashboard.settings)}
                        >
                            Change
                        </Button>
                    </HStack>
                </VStack>
            )} */}

            {isLoading && <Loader height="auto" width="100%" size="lg" position="relative" />}
            {availableSlots && availableSlots.length > 0 && !isLoading && (
                <>
                    {/* <CustomText color="mainText" size="md">
                        What time works best?
                    </CustomText> */}
                    <Divider border="border" my={4} borderWidth="0.5px" />
                    <Text
                        color="mainText"
                        fontWeight={400}
                        fontSize="18px"
                        lineHeight="28px"
                        textAlign="center"
                        marginBottom="24px"
                    >
                        Available Time Slots
                    </Text>
                    <SimpleGrid columns={{ base: 2, sm: 2, md: 3 }} spacing={2} width="100%">
                        {availableSlots?.map((slot, index) => (
                            <AvailableSlot
                                key={`key ${index}`}
                                slot={slot}
                                onNextClick={() => {
                                    setSelectedSlot(slot);
                                    onNext();
                                }}
                                onSelect={() => onSelect(index)}
                            />
                        ))}
                    </SimpleGrid>
                    {(() => {
                        const selected = availableSlots.find(slot => slot.isSelected);
                        return (
                            <Button
                                width="100%"
                                height="49px"
                                type="button"
                                mt={3}
                                isDisabled={!selected}
                                onClick={() => {
                                    if (selected) {
                                        setSelectedSlot(selected);
                                        onNext();
                                    }
                                }}
                                color={!selected ? 'subText' : 'white'}
                                bgColor={!selected ? 'calendarViewBg' : 'primary.light'}
                                _hover={selected ? { bgColor: 'primary.dark' } : undefined}
                            >
                                Book Session
                            </Button>
                        );
                    })()}
                </>
            )}
        </VStack>
    );
};

export default SessionAvailability;
